import { render } from "./EditPRAttachment.vue?vue&type=template&id=050ab499"
import script from "./EditPRAttachment.vue?vue&type=script&lang=js"
export * from "./EditPRAttachment.vue?vue&type=script&lang=js"

import "./EditPRAttachment.vue?vue&type=style&index=0&id=050ab499&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__